// src/components/Button.jsx
import React from 'react';
import { GoArrowUpRight } from "react-icons/go";

const ButtonBorder = ({ text, onClick, type = "button", className = "" }) => {
  return (
    <>
      <button onClick={onClick} className="flex items-center justify-center space-x-3 px-2 py-2 textwhite text-lg cursor-pointer w-full border border-[#FFFFFF] hover:bg-[#111827]/40 transition-all duration-300 rounded" type={type}>
        <p>{text}</p>
        <GoArrowUpRight className="w-5 h-5 textwhite" />
      </button>
    </>
  );
};

export default ButtonBorder;